<script>
import DsnSpellingRulesService from "@/common/api/dsn-spelling-rules.service";
import RouteHelper from "@/common/route-helper";
import ContentCard from "@/components/ContentCard.vue";
import DsnSpellingRuleModal from "@/components/modals/DsnSpellingRuleModal.vue";
import NestedList from "@/components/NestedList.vue";
import { QUERY_DSN_PARAGRAPH_KEY } from "@/router/query-params";

export default {
  name: "DsnSpellingRulesView",
  components: {
    DsnSpellingRuleModal,
    NestedList,
    ContentCard
  },
  props: {
    activeParagraph: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      isFetching: false,
      rules: null
    };
  },
  created() {
    this.fetchRules();
  },
  methods: {
    async fetchRules() {
      this.isFetching = true;

      try {
        this.rules = await DsnSpellingRulesService.fetchTreeList();
      } finally {
        this.isFetching = false;
      }
    },
    showRule(paragraph) {
      const routeHelper = new RouteHelper(this.$router);
      routeHelper.pushQueryParam({
        [QUERY_DSN_PARAGRAPH_KEY]: paragraph
      });
    },
    hideRule() {
      const routeHelper = new RouteHelper(this.$router);
      routeHelper.removeQueryParam(QUERY_DSN_PARAGRAPH_KEY);
    }
  }
};
</script>

<template>
  <main class="dsn-spelling-rules mb-5">
    <div class="container p-0">
      <div class="row">
        <div class="col">
          <h1 class="dsn-spelling-rules__header">Retskrivnings&shy;regler</h1>

          <ContentCard class="dsn-spelling-rules__content">
            <template v-if="isFetching"> {{ $t("general.loading") }} </template>
            <NestedList
              v-else-if="rules"
              :items="rules"
              list-class="dsn-spelling-rules__list"
              item-class="dsn-spelling-rules__list-item"
            >
              <template #itemContent="{ item }">
                <div class="dsn-spelling-rules__list-item-content">
                  <span class="dsn-spelling-rules__list-item-content-indent">
                    <a
                      v-if="item.paragraph"
                      href="#"
                      class="dsn-spelling-rules__list-item-content-link"
                      @click.stop.prevent="showRule(item.paragraph)"
                      >§ {{ item.paragraph }}.</a
                    >
                  </span>
                  {{ item.name }}
                </div>
              </template>
            </NestedList>
          </ContentCard>
        </div>
      </div>
    </div>
    <DsnSpellingRuleModal
      :paragraph="activeParagraph"
      @close="hideRule()"
      @click-paragraph="showRule($event)"
    />
  </main>
</template>
